const IssuerCountTypes = [
  "Default",
  "All",
  "ExHedges",
  "ExDerivatives",
];

export default IssuerCountTypes;
